import { PremiumTrialsNotFoundError } from "@seneca/trials-service-client";

import { throttledLogError } from "seneca-common/utils/apiStates";

export default function errorHandler(
  error: Error,
  {
    errorAction,
    successAction
  }: {
    errorAction: () => void;
    successAction: () => void;
  }
): void {
  if (error instanceof PremiumTrialsNotFoundError) {
    return successAction();
  }

  errorAction();
  throttledLogError(error);
}
